import ModalBS from './ModalBS.jsx';

export default ModalBS;